var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var LearningSeries = require("lib/academic/LearningSeries");
var TutorialDisplay = require("components/users/teachers/tutorials/TutorialDisplay");

require("users/teachers/tutorials/tutorials_page");

class TutorialsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			completedVideos: [], completedActions: [], currentVideo: null
		};
	}

	changeVideo(newVideo) {
		this.setState({ currentVideo: newVideo });
	}

	changeLevel(newLevel) {
		var currentVideo = this.state.currentVideo;
		var firstIncompleteVideo = LearningSeries.firstIncompleteVideoInModuleAtLevel(currentVideo.module, newLevel, this.state.completedVideos);
		this.setState({ currentVideo: firstIncompleteVideo });
	}

	changeModule(newModule) {
		var firstIncompleteVideo = LearningSeries.firstIncompleteVideoInModule(newModule, this.state.completedVideos);
		this.setState({ currentVideo: firstIncompleteVideo });
	}

	completeVideo(videoKey) {
		var params = {
			admin: { completed_tutorial_video: videoKey },
			embed: "admin.completed_tutorial_videos"
		};
		CurrentUser.api().patchAdmin(CurrentUser.get().id, params, $wr.apiHandler((response) => {
			this.setState({ completedVideos: response.admin.completed_tutorial_videos });
		}));
	}

	renderModuleNav(moduleKey) {
		var moduleNavClassName = "navModuleHeaderLink";
		if (this.state.currentVideo.module == moduleKey) {
			moduleNavClassName += " selectedLinkClass";
		}

		return (
			<div className={ moduleNavClassName } key={ "link-" + moduleKey }
				onClick={ this.changeModule.bind(this, moduleKey) }>
				{ LearningSeries.moduleName(moduleKey) }
			</div>
		);
	}

	render() {
		if (this.state.currentVideo == null) {
			return (
				<div className="tutorialsPage container">
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		}

		var currentVideo = this.state.currentVideo;
		var currentModule = currentVideo.module;
		var tutorialDisplay = (
			<TutorialDisplay video={ currentVideo }
				action={ LearningSeries.action(currentVideo.key) }
				allVideos={ LearningSeries.videos(currentModule, currentVideo.level) }
				completedVideos={ this.state.completedVideos }
				completedActions={ this.state.completedActions }
				changeVideoF={ this.changeVideo }
				changeLevelF={ this.changeLevel }
				changeModuleF={ this.changeModule }
				completeVideoF={ this.completeVideo } />
		);


		var moduleNavDisplay = [];
		_.map(LearningSeries.MODULES, (module, index) => {
			moduleNavDisplay.push(this.renderModuleNav(module));
			if (index < LearningSeries.MODULES.length - 1) {
				moduleNavDisplay.push(<span className="verticalDivider" key={ "div-" + index }></span>);
			}
		});

		return (
			<div className="tutorialsPage container">
				<header className="pageHeader hideOnPrint">
					<h1>Learning Series</h1>
				</header>
				<div className="tutorialsNavContainer">
					{ moduleNavDisplay }
				</div>

				{ tutorialDisplay }
			</div>
		);
	}

	componentDidMount() {
		var embeds = "admin.completed_tutorial_videos,admin.completed_tutorial_actions";
		CurrentUser.api().getAdmin(CurrentUser.get().id, { embed: embeds }, $wr.apiHandler((response) => {
			var admin = response.admin;
			this.setState({
				completedVideos: admin.completed_tutorial_videos,
				completedActions: admin.completed_tutorial_actions,
				currentVideo: LearningSeries.firstIncompleteVideoInModule(LearningSeries.QUICK_MODULE, admin.completed_tutorial_videos)
			});
		}));

	}
}

TutorialsPage.propTypes = PageStrictPropTypes({
});

module.exports = TutorialsPage;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/tutorials/TutorialsPage.js